<template>
  <div class="content">
    <div class="hint-txt">
      智能客服下班啦！
    </div>
<!--    <navBar></navBar>-->
<!--    <div class="contain">-->
<!--      <div class="message" id="messageBox" ref="messageBox" :style="{height: messageBoxHt}">-->
<!--        <div v-for="(it,index) in message" :key="index">-->
<!--          <div v-if="it.id" class="item other clear">-->
<!--            &lt;!&ndash;          <div class="avatar" style="background-image: url('../assets/znzs.png')"></div>&ndash;&gt;-->
<!--            <img class="avatar" src="../assets/znzs.png" alt="" />-->
<!--            <div class="cont">-->
<!--              <div>-->
<!--                <p v-if="!it.is_translate">{{it.content}}</p>-->
<!--                <p v-if="it.is_translate">{{it.content_sec}}</p>-->
<!--                <div class="translate-box">-->
<!--                  <span @click="translateFirst(it,'zh')">中文</span> <span @click="translateFirst(it,'en')">EN</span> <span @click="showPopup(it)">多国翻译</span> <span @click="showDefault(it)" v-if="it.is_translate" class="show-default"><van-icon name="exchange" />显示原文</span>-->
<!--                </div>-->
<!--                &lt;!&ndash;              <div @click="showDefault(it)" v-if="it.is_translate" class="show-default"><van-icon name="exchange" />显示原文</div>&ndash;&gt;-->
<!--              </div>-->

<!--              <div v-if="it.que" class="que">-->
<!--                <div class="p-box" v-for="(que,i) in it.que" :key="i">-->
<!--                  <p v-if="!que.is_translate" @click.stop="details(que)">{{i + 1}}、{{que.title}}</p>-->
<!--                  <p v-if="que.is_translate" @click.stop="details(que)">{{i + 1}}、{{que.content_sec}}</p>-->
<!--                  <div class="translate-box-sec">-->
<!--                    <span @click="translateSec(que,'zh')">中文</span> <span @click="translateSec(que,'en')">EN</span> <span @click="showPopup(que)">多国翻译</span> <span @click="showDefault(que)" v-if="que.is_translate" class="show-default"><van-icon name="exchange" />显示原文</span>-->
<!--                  </div>-->
<!--                  &lt;!&ndash;                <div @click="showDefault(que)" v-if="que.is_translate" class="show-default"><van-icon name="exchange" />显示原文</div>&ndash;&gt;-->
<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else class="item mine clear">-->
<!--            &lt;!&ndash;          <div :style="{backgroundImage: 'url(' + img('icon_logo.png') + ')'}" class="avatar"></div>&ndash;&gt;-->
<!--            <img class="avatar" src="../assets/logo.jpg" alt="" />-->
<!--            <div class="cont">-->
<!--              <p>{{it.content}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="null-box"></div>-->
<!--      <div class="bar clear justify-align" ref="barH">-->
<!--        <input v-model="msg" type="text" class="fl msg-int" />-->
<!--        <div @click="send" class="send-btn fr">发送</div>-->
<!--      </div>-->

<!--    </div>-->
    <!--  弹出框内容-->
    <van-popup v-model="pop_show" position="top" closeable :style="{ height: '25%' }">
      <div class="list-language-box justify-align">
        <span class="language-item" v-for="(item,i) in languageList" :key="i" @click="languageSelect(i)">{{item}}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import navBar from "@/components/navBar";
import { botChat,languageList,translateSubmit } from '@/api/xieyi'
export default {
  name: 'Service',
  data () {
    return {
      message: [{
        id: 1,
        content: '您好，我是您的智能助手小豪，请问有什么可以帮助到您？',
        content_sec:'',
        is_translate:false
      }],
      msg: '',
      messageBoxHt:'500',
      source_type:'system',// 模块来源，system平台客服，goods商品客服，liveroom直播间客服
      keyword:'', // 关键字
      source_id: '', // 模块id，当模块来源不是平台时必填，模块id为主键id，如商品id
      pop_show:false,
      languageList: [],
      translateCurrItem:'',
      currLanguage:'',
      pIndex:'', // 父级点前index：pIndex
      cIndex:'' // 子index
    }
  },
  components:{
    // navBar
  },
  created() {
    if (this.$route.query.type != undefined){
      this.source_type = this.$route.query.type
    } else {
      this.source_type = 'system'
    }
    console.log('log',this.$route.query.type)
    // this.getLanguageList()
  },
  mounted(){
    // this.$nextTick(()=>{ // 页面渲染完成后的回调
    //   let heightCss = this.$refs.barH.offsetHeight;
    //   // console.log(heightCss)
    //   let messageBoxh = this.$refs.messageBox
    //   let wh = document.documentElement.clientHeight
    //   this.messageBoxHt = (wh-heightCss) + 'px'
    // })
  },
  methods: {
    showDefault(it){
      this.translateCurrItem = it
      this.translateCurrItem.is_translate = false
      this.$forceUpdate()
    },
    translateFirst(it,type,index){ // 单个点击翻译的话
      // console.log('it',it)
      // console.log(type)
      // this.pIndex = index
      this.translateCurrItem = it
      this.currLanguage = type
      this.clickTranslateSubmit()
    },
    translateSec(item,type,pIndex,cIndex){ // 父级点前index：pIndex
      // console.log('item',item)
      // console.log('pIndex',pIndex)
      // console.log('cIndex',cIndex)
      // this.pIndex = pIndex
      // this.cIndex = cIndex
      this.translateCurrItem = item
      this.currLanguage = type
      this.clickTranslateSubmit()
    },
    languageSelect(i){ // 弹框内容选中的语言
      console.log(i)
      this.currLanguage = i
      this.pop_show = false
      this.clickTranslateSubmit()
    },
    showPopup(item) { // 更多语言
      // console.log(item)
      this.translateCurrItem = item
      this.pop_show = true
    },
    clickTranslateSubmit(){ // 调取接口

      const data = {
        text:this.translateCurrItem.title? this.translateCurrItem.title : this.translateCurrItem.content,
        target_language:this.currLanguage
      }
      let that = this
      translateSubmit(data).then(res=>{
        if (res.code==200){
          let txt = res.data
          let obj = that.translateCurrItem
          obj.is_translate = true
          obj.content_sec = txt
          that.translateCurrItem = obj
          // console.log('translateCurrItem',this.translateCurrItem)
          this.$forceUpdate()
        } else
        {
          this.$toast(res.message)
        }
      })
    },
    getLanguageList(){
      languageList().then(res=>{
        if (res.code==200){
          this.languageList = res.data
        } else
        {
          this.$toast(res.message)
        }
      })
    },
    send () {
      if (this.msg.trim().length) {
        this.message.push({
          content: this.msg
        })
        let data = {
          keyword: this.msg,
          source_type:this.source_type,
          // source_id:this.source_id
        }
        botChat(data).then(res => {
          if(res.code == 200)
          {
            // console.log('res',res.data)
            if (res.data.length) {
              if (res.data.length == 1) {
                this.message.push({
                  id: 1, // 时间也就是id 用来显示翻译内容
                  content: res.data[0].content,
                  content_sec:'',
                  is_translate:false
                })
              } else {
                // console.log('length 大于1')
                let arr = res.data
                arr.forEach(function(val,key,arr){
                  arr[key].is_translate=false
                  arr[key].content_sec = ''
                })

                this.message.push({
                  id: 1, // 时间也就是id 用来显示翻译内容
                  content: '您是否想咨询以下问题，请点击相关的问题获取详情',
                  is_translate:false,
                  content_sec:'',
                  que: [].concat( arr )
                })
                // console.log(this.message)
              }

            } else {
              this.message.push({
                id: 1, // 时间也就是id 用来显示翻译内容
                content: '对不起，您的问题我暂时没法理解，您试试换另一种问法。如需人工服务，欢饮您致官方客服热线号码：400-900-1408'
              })
            }

            // this.toScroll()
            this.$nextTick(() => {
              let msg = document.getElementById('messageBox') // 获取对象
              msg.scrollTop = msg.scrollHeight // 滚动高度
            })
            this.msg = ''
            // console.log(this.message)
          }
          else
          {
            this.$toast(res.message)
          }
        })
      } else {
        this.$toast('请输入内容')
      }

    },
    randomID() {
      return Number(Math.random().toString().substr(2,0) + Date.now()).toString(36);
    },
    toScroll () {
      let div = document.getElementById('messageBox');
      div.scrollTop = div.scrollHeight
    },
    details (data) {
      this.message.push({
        id: 1,
        content: data.content,
      })
      this.toScroll()
    }
  }
}
</script>

<style lang="scss" scoped>
.clear {
  &::after {
    content: '';
    display: block;
    clear: both;
  }
}
.hint-txt{
  position: absolute;left: 0;top: 30%;
  text-align: center;width: 100%;
}
.contain {
  width: 100%;
  height: 100%;
  background: #f0f2f8;
}


.message {
  box-sizing: border-box;
  padding: 0.4rem;
  width: 100%;
  height: calc( 100% - 1.42rem );
  overflow: hidden;
  overflow-y: scroll;
  .item {
    margin-bottom: 20px;
    .avatar {
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: #fff;
    }
    .cont {
      color: #333;
      font-size: 28px;
      max-width: 6.5rem;
      word-break: break-all;
      .time {
        padding-top: 0.2rem;
        font-size: 0.3rem;
        color: #999;
      }
      .que {
        padding-top: 0.3rem;
        .p-box{
          margin-bottom: 0.4rem;

        }
        p {
          line-height: 0.6rem;
          text-decoration: underline;
          color: #00acff;
          display: block;

        }
      }
    }
  }
  .other {
    .avatar {
      float: left;
      margin-right: 0.4rem;
      background-color: #00acff;
      background-size: 80% 80%;
    }
    .cont {
      float: left;
      background: #fff;
      padding: 0.3rem;
      border-radius: 0.3rem;
    }
  }
  .mine {
    .avatar {
      float: right;
      margin-left: 0.4rem;
    }
    .cont {
      float: right;
      background: #b7e1f8;
      padding: 0.3rem;
      border-radius: 0.3rem;
    }
  }
}
.translate-box{
  color: #00acff;margin-top: 10px;
  span{
    display: inline-block;margin-right: 10px;text-decoration: underline;
  }
  .show-default{
    color: #282828;text-decoration: none;
  }
}
.translate-box-sec{
  color: #00acff;margin-top: 10px;
  span{
    display: inline-block;margin-right: 10px;
  }
  .show-default{
    color: #282828;
  }
}
.show-default{
  margin-top: 10px;
}
.bar {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  background: #ebeef5;
  height: 1rem;
  padding: 0.18rem 0.18rem 30px;
  .emoji {
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    i {
      font-size: 0.8rem;
    }
  }
  .msg-int {
    margin-left: 0px;
    width: 500px;
    height: 1rem;
    background: #fff;
    border-radius: 0.4rem;
    border: none;
    outline: none;
    padding: 0 0.4rem;
    font-size: 28px;
    &:focus {
      border: none;
      outline: none;
    }
  }
  .send-btn {
    position: relative;
    top: 0.04rem;
    width: 1.8rem;
    padding: 18px 0;
    //height: 0.9rem;
    //line-height: 0.9rem;
    text-align: center;
    font-size: 28px;
    color: #333333;
    background: #FDD80D;
    border-radius: 0.6rem;
    transition: all 300ms;
  }
  .disable {
    opacity: 0.4;
  }
}
.list-language-box{
  width: 80%;margin: 150px auto 0;
  .language-item{
    color: #00d0ff;
    text-decoration: underline;
  }
}
</style>
